import React from 'react'
import { Button, Icon, Typography } from 'components'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from '../../constants'

const { SUCCESS } = colors

const useStyles = makeStyles({
  passwordUpdatedInfoContainer: {
    margin: '32px 40px',
    display: 'flex',
    flexDirection: 'column',
  },
  passwordUpdateTitle: {
    marginBottom: 16,
  },
  successPasswordUpdateIcon: {
    color: SUCCESS,
    fontSize: 32,
    marginRight: 8,
  },
  passwordUpdateBtn: {
    alignSelf: 'flex-end',
  },
})

const SuccessPasswordUpdate = ({ submit }) => {
  const classes = useStyles()
  return (
    <div className={classes.passwordUpdatedInfoContainer}>
      <Typography className={classes.passwordUpdateTitle} variant="h4">
        <Icon style={classes.successPasswordUpdateIcon} iconClass="las la-check-circle" />
        Password Updated!
      </Typography>
      <Typography variant="subtitle1">
        Your password has been reset successfully. Use your new password to log in.
      </Typography>
      <Button variant="primary" type="submit" className={classes.passwordUpdateBtn} onClick={submit}>
        Log In
      </Button>
    </div>
  )
}

export default SuccessPasswordUpdate
